
import Vue from 'vue';
import { CvInlineLoading } from '@carbon/vue';

export default Vue.extend({
  name: 'SmallDetailsLoader',
  components: {
    CvInlineLoading,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.$modal.show('small-details-loader');
      } else {
        this.$modal.hide('small-details-loader');
      }
    },
  },

  mounted() {
    if (this.isOpen) {
      this.$modal.show('small-details-loader');
    }
  },
});
